import styled from 'styled-components';
import { Scrollbars } from 'react-custom-scrollbars';
import { useSelector } from 'react-redux';
import DebugMultiPressAlert from '../../../../../components/debug/DebugMultiPressAlert';

export default function InformationTab({ elementID }) {
  const obLevel1 = useSelector(
    (state) => state.currentPage?.elementLevels?.level1?.[elementID]
  );

  return (
    <Container>
      <div className="pr-2">
        <h3 className="category-header">
          <span>
            {`${obLevel1?.category || ''} / ${obLevel1?.subcategory || ''}`}
          </span>
          <span className="float-right">{obLevel1?.note}</span>
        </h3>
        <Scrollbars style={{ height: '385px', paddingRight: '10px' }}>
          {obLevel1?.hasFormat ? (
            <div
              dangerouslySetInnerHTML={{
                __html: obLevel1?.obligation,
              }}
            />
          ) : (
            <div style={{ whiteSpace: 'pre-line' }}>{obLevel1?.obligation}</div>
          )}
        </Scrollbars>
      </div>
      <InformationRight>
        <Scrollbars style={{ height: '385px', paddingRight: '10px' }}>
          <DebugMultiPressAlert info={`ID: ${obLevel1?.id}`}>
            <h4>{`CODE: ${obLevel1?.hex || '------'}`}</h4>
          </DebugMultiPressAlert>
        </Scrollbars>
      </InformationRight>
    </Container>
  );
}

const Container = styled.div`
  display: grid;
  grid-template-columns: 0.8fr 0.2fr;
  height: 400px;
`;

const InformationRight = styled.div`
  border-left: 1px solid #ddd;
  padding: 10px;
`;
